import { FloatingFormItem } from '@/components/_common';
import {
  useStoneDeviceCreate,
  useStoneDeviceUpdate,
} from '@/core/domain/stone/devices/devices.hooks';
import { StoneDevice } from '@/core/domain/stone/devices/devices.types';
import { StoneAccount } from '@/core/domain/stone/stoneAccount/stoneAccount.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Form, Input, Modal, Radio } from 'antd';
import { useEffect } from 'react';

interface Props {
  device?: StoneDevice;
  opened: boolean;
  onClose: VoidFunction;
  stoneAccount?: StoneAccount;
}

export default function StoneDeviceModal({
  device,
  onClose,
  opened,
  stoneAccount,
}: Props) {
  const [form] = Form.useForm<{ serialNumber: string; active: boolean }>();

  const requiredField = useDefaultEmptyFieldError();

  const stoneDeviceCreate = useStoneDeviceCreate();
  const stoneDeviceUpdate = useStoneDeviceUpdate();

  const isLoading = stoneDeviceUpdate.isLoading || stoneDeviceCreate.isLoading;

  useEffect(() => {
    if (device && opened) {
      form.setFieldsValue({
        active: device.active,
        serialNumber: device.serialNumber,
      });
    }
  }, [device, opened]);

  function handleClose() {
    form.resetFields();
    onClose();
  }

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      if (device?.id) {
        await stoneDeviceUpdate.mutateAsync({
          ...values,
          deviceId: device.id,
        });
      } else if (stoneAccount) {
        await stoneDeviceCreate.mutateAsync({
          ...values,
          stoneAccountId: stoneAccount?.id,
        });
      }

      handleClose();
    } catch {}
  }

  return (
    <Modal
      open={opened}
      onCancel={handleClose}
      onOk={handleSubmit}
      title={
        device ? 'Atualizar dispositivo Stone' : 'Cadastrar dispositivo Stone'
      }
      maskClosable={false}
      okText="Salvar dispositivo"
      destroyOnClose
      confirmLoading={isLoading}
      closable={!isLoading}
    >
      <Form form={form} layout="vertical">
        <p>
          Preencha o campo para {device ? 'atualizar' : 'cadastrar'} o
          dispositivo da Stone.
        </p>

        <FloatingFormItem
          name="serialNumber"
          label="Número do terminal (maquininha)"
          rules={[requiredField]}
        >
          <Input disabled={isLoading} />
        </FloatingFormItem>

        <Form.Item
          name="active"
          label="Situação"
          rules={[requiredField]}
          initialValue={true}
        >
          <Radio.Group
            disabled={isLoading}
            buttonStyle="solid"
            optionType="button"
            options={[
              { value: true, label: 'Ativado' },
              { value: false, label: 'Desativado' },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
